module.exports = __webpack_public_path__ + "media/images/emblems/Waeldi-06728598a1aa15c304bb11ff456e026e.gif";